class Summary {
  static options = {
    timeout: 350,
    left: 37,
    right: 39,
    down: 40,
  };

  constructor(element, options) {
    this._element = element;
    this._options = { ...options };
    this._cacheSelectors();
    this._initialize();
  }

  _cacheSelectors() {
    this.tabbed = this._element;
    this.back = this.tabbed.parentNode.querySelector('.filters__back__button');
    if (this.back) {
      this.activeTitle = this.back.querySelector('span');
    }
    this.filters =
      this.tabbed.parentNode.parentNode.parentNode.parentNode.querySelector('.filters');
    this.tablist = this.tabbed.querySelector('ul.summary__nav');
    this.tabs = this.tablist.querySelectorAll('a');
    this.panels = this.tabbed.querySelectorAll(`[id^="${this._options.hash}"]`);
  }

  _switchTab(oldTab, newTab) {
    newTab.focus();
    const index = Array.prototype.indexOf.call(this.tabs, newTab);
    const oldIndex = Array.prototype.indexOf.call(this.tabs, oldTab);
    this.panels[oldIndex].setAttribute('data-transition', this._options.animatein);
    this.panels[oldIndex].setAttribute('data-transition', '');
    if (this.filters !== null) {
      this.filters.setAttribute('data-collapsed', 'false');
    }
    const t = setTimeout(() => {
      newTab.removeAttribute('tabindex');
      newTab.setAttribute('aria-selected', 'true');
      this.panels[index].setAttribute('data-transition', this._options.animateout);
      if (this.back !== null) {
        this.activeTitle.textContent = '';
        this.activeTitle.textContent = newTab.querySelector('span').textContent;
      }
      oldTab.removeAttribute('aria-selected');
      oldTab.setAttribute('tabindex', '-1');
      this.panels[oldIndex].hidden = true;

      this.panels[index].hidden = false;
      clearTimeout(t);
    }, this._options.timeout);
  }

  _toggleTab(newTab, show) {
    if (!show) {
      newTab.blur();
      const index = Array.prototype.indexOf.call(this.tabs, newTab);
      this.filters.setAttribute('data-collapsed', 'true');
      //panels[oldIndex].setAttribute('data-transition', this._options.animatein)
      this.panels[index].setAttribute('data-transition', '');

      const t = setTimeout(() => {
        newTab.removeAttribute('aria-selected');
        newTab.setAttribute('tabindex', '-1');
        this.panels[index].hidden = true;
        clearTimeout(t);
      }, this._options.timeout);
    } else {
      newTab.focus();
      const index = Array.prototype.indexOf.call(this.tabs, newTab);
      this.filters.setAttribute('data-collapsed', 'false');
      newTab.removeAttribute('tabindex');
      newTab.setAttribute('aria-selected', 'true');
      if (typeof this.back !== 'undefined') {
        this.activeTitle.textContent = '';
        this.activeTitle.textContent = newTab.querySelector('span').textContent;
      }
      this.panels[index].setAttribute('data-transition', this._options.animateout);
      this.panels[index].hidden = false;
    }
  }

  _initialize() {
    this.tablist.setAttribute('role', 'tablist');

    Array.prototype.forEach.call(this.tabs, (tab, i) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('id', `tab${i + 1}`);
      tab.setAttribute('tabindex', '-1');
      tab.parentNode.setAttribute('role', 'presentation');
      // eslint-disable-next-line complexity
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        const currentTab = this.tablist.querySelector('[aria-selected]');
        if (e.currentTarget !== currentTab && currentTab !== null) {
          this._switchTab(currentTab, e.currentTarget);
        } else if (currentTab !== null && this._options.mintabs === '0') {
          this._toggleTab(e.currentTarget, false);
        } else if (this._options.mintabs === '0') {
          this._toggleTab(e.currentTarget, true);
        }
      });

      // eslint-disable-next-line complexity
      tab.addEventListener('keydown', (e) => {
        const index = Array.prototype.indexOf.call(this.tabs, e.currentTarget);

        const dir =
          e.which === this._options.left
            ? index - 1
            : e.which === this._options.right
              ? index + 1
              : e.which === this._options.down
                ? 'down'
                : null;
        if (dir !== null) {
          e.preventDefault();
          // eslint-disable-next-line no-unused-expressions
          dir === 'down'
            ? this.panels[i].focus()
            : this.tabs[dir]
              ? this._switchTab(e.currentTarget, this.tabs[dir])
              : // eslint-disable-next-line no-void
                void 0;
        }
      });
    });
    if (this.back) {
      this.back.addEventListener('click', (e) => {
        e.preventDefault();
        const currentTab = this.tablist.querySelector('[aria-selected]');
        currentTab.click();
      });
    }

    Array.prototype.forEach.call(this.panels, (panel, i) => {
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('tabindex', '-1');
      //const id = panel.getAttribute('id');
      panel.setAttribute('aria-labelledby', this.tabs[i].id);
      panel.hidden = true;
    });

    const startTab = this.tablist.querySelector('[aria-selected]');
    if (startTab === null) {
      return;
    }
    startTab.focus();
    startTab.removeAttribute('tabindex');
    const start = Array.prototype.indexOf.call(this.tabs, startTab);
    this.panels[start].hidden = false;
  }
}

export default Summary;
